import HookLoader from './HookLoader/HookLoader';
import useFetch from './useFetch';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;


interface Props {
    setEnv: React.Dispatch<React.SetStateAction<boolean>>;
}

const ResourceEnvironment = ({ setEnv }: Props) => {
    const url = `${baseUrl}/mobilyTheme4/BzFvwmzXvs`;
    const req = { "data": "APIGEE_BM_BASE_URL~CEM_KEY~APIGEE_BASE_URL~MOBILY_GOOGLE_MAP_API_KEY~CEM_KEYCLOAK_PUBLIC_KEY" };
    const { response, loading }: any = useFetch(url, req, setEnv);

    if (response) {
        !!!win["cem_key"] && (win["cem_key"] = response.CEM_KEY);
        !!!win["apigee_base_api_url"] && (win["apigee_base_api_url"] = response.APIGEE_BASE_URL);
        !!!win["apigee_bm_base_url"] && (win["apigee_bm_base_url"] = response.APIGEE_BM_BASE_URL);
        !!!win["googleMapKey"] && (win["googleMapKey"] = response.MOBILY_GOOGLE_MAP_API_KEY);
        !!!win["errorPageURL"] && (win["errorPageURL"] = '/wps/portal/web/personal/store/error');
        !!!win["PK"] && (win["PK"] = response.CEM_KEYCLOAK_PUBLIC_KEY);
    }

    return (
        <div>
            {loading && <HookLoader loading={loading} />}
        </div>
    )
}

export default ResourceEnvironment